import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { composePath } from '@culture/common-helpers/params';
import {
	MetaPropType,
	NavigationPropType,
	PaginatedItemsPropType,
	PromoBlockPropType
} from 'propTypes/common';
import Container from 'components/Container';
import { Layout, LayoutBlock } from 'components/Layout';

import CatalogTitleHeading from 'components/CatalogTitleHeading';
import CatalogDescription from 'components/CatalogDescription';
import { BroadcastType, PublicationType } from 'propTypes/entities';
import Catalog from './components/Catalog';
import Controls from './components/Controls';

import styles from './styles.module.scss';
import RelatedEntities from './components/RelatedEntities';

const NewsTemplate = ({
	news,
	menu,
	meta,
	relatedEntities,
	urlParams,
	catalogDescription,
	topPromoBlock
}) => {
	const { push } = useRouter();
	const { total } = news;

	const changeUrl = (params) => {
		const { rubric, ...restParams } = params;
		const basePath = '/news';
		const isRubricReset = rubric === '';
		if (isRubricReset) {
			return push(basePath);
		}
		const isNewRubric = rubric && rubric !== urlParams?.rubric;

		if (isNewRubric) {
			return push(`${basePath}/${rubric}`);
		}

		const prefix = rubric ? `${basePath}/${rubric}` : basePath;

		const filterParams = {
			...restParams,
			page: null
		};

		const path = composePath(prefix, filterParams);
		return push(path);
	};

	const handleFilterChange = useCallback(
		(name, value) => {
			const currentValue = urlParams[name] || '';
			if (value !== currentValue) {
				const params = {
					...urlParams,
					[name]: value,
					page: null
				};

				changeUrl(params);
			}
		},
		[urlParams]
	);

	const emptyMessage = 'К сожалению, новостей по вашему запросу не найдено ';

	return (
		<Layout {...{ menu, meta, topPromoBlock }}>
			<RelatedEntities entities={relatedEntities} />

			<LayoutBlock gutter="mediumConstant">
				<Container innerClassName={styles.Title}>
					<CatalogTitleHeading
						{...{ headingTitle: meta?.headingTitle, total }}
					/>
				</Container>
			</LayoutBlock>

			{!!catalogDescription && (
				<LayoutBlock gutter="mediumConstant">
					<Container>
						<CatalogDescription {...{ text: catalogDescription }} />
					</Container>
				</LayoutBlock>
			)}

			<LayoutBlock gutter="mediumConstant">
				<Container>
					<Controls
						{...{
							urlParams,
							handleFilterChange
						}}
					/>
				</Container>
			</LayoutBlock>

			<LayoutBlock>
				<Container>
					<Catalog {...{ news, emptyMessage }} />
				</Container>
			</LayoutBlock>
		</Layout>
	);
};

NewsTemplate.propTypes = {
	menu: NavigationPropType.isRequired,
	meta: MetaPropType.isRequired,
	urlParams: PropTypes.object.isRequired,
	news: PaginatedItemsPropType,
	relatedEntities: PropTypes.shape({
		broadcast: BroadcastType,
		publications: PropTypes.arrayOf(PublicationType)
	}).isRequired,
	catalogDescription: PropTypes.string.isRequired,
	topPromoBlock: PromoBlockPropType,
	rubricName: PropTypes.string,
	incutGridPromoBlock: PropTypes.array
};

export default NewsTemplate;
